import { HeaderTabsContext } from "@/contexts/tabsContext/HeaderTabsContextObject";
import { use } from "react";

export function useHeaderTabs() {
	const context = use(HeaderTabsContext);

	if (!context) throw new Error("useHeaderTabs must be used within a HeaderTabsProvider");

	return context;
}

export default useHeaderTabs;
